const videosAr = [
  {
    id: 'raneem-azzam-mpc',
    student: 'رنيم عزام',
    major: 'تعليم',
    youtubeId: 'Fqe1HpZOUSc',
  },
  {
    id: 'Ashraf-Abou-Ziki-mpc',
    student: 'أشرف أبو زكي',
    major: 'علاج فيزيائي',
    youtubeId: '-HzCW18dB0A',
  },
  {
    id: 'Nidal-Hassan-mpc',
    student: 'د. نضال حسن',
    major: 'جراحة بيطرية',
    youtubeId: 'OZQszPPiUKE',
  },
  {
    id: 'Nour-Mahmoud-mpc',
    student: 'المهندسة نور محمود',
    major: 'هندسة كمبيوتر واتصالات',
    youtubeId: 'OldIZ-aSPa4',
  },
  {
    id: 'Mira-Abou-Dargham-mpc',
    student: 'د.ميرا أبو ضرغم',
    major: 'صيدلي',
    youtubeId: 'v6jK2hJV2rY',
  },
  {
    id: 'Rima-Bou-Karroum-mpc',
    student: 'المهندسة ريما أبو كروم',
    major: 'هندسة زراعية',
    youtubeId: 'EBXFpcXGFwU',
  },
  {
    id: 'Hazar-Khattar-mpc',
    student: 'هازار خطار',
    major: 'العلاج السلوكي وعلاج الاحتياجات الخاصة',
    youtubeId: 'UbtYV9cLtx4',
  },
  {
    id: 'Wida-Bou-Hadir-mpc',
    student: 'ويدا بوهدير',
    major: 'ادارة أعمال',
    youtubeId: 'LwDDdpyL6DY',
  },
  {
    id: 'Bilal-Nasr-mpc',
    student: 'بلال نصر',
    major: 'هندسة داخلية',
    youtubeId: 'EWJfni4u8b8',
  },
  {
    id: 'Heba-Btadini-mpc',
    student: 'هبه بتديني',
    major: 'التغذية وعلم التغذية',
    youtubeId: 'JlJNYD2GPhs',
  },
  {
    id: 'Ranim-Ghanem-mpc',
    student: 'رنيم غانم',
    major: 'راديو وتلفزيون',
    youtubeId: 'tsbPd07xSB0',
  },
  {
    id: 'Hanadi-Rajeh-mpc',
    student: 'هنادي راجح',
    major: 'التربية الرياضية',
    youtubeId: 'ydsGRWZdZoo',
  },
  {
    id: 'Iman-Dbeissy-mpc',
    student: 'المهندسة ايمان الدبيسي',
    major: 'هندسة معمارية',
    youtubeId: 'MIkqG2zFxY8',
  },
  {
    id: 'Alaa-Ghanem-mpc',
    student: 'علاء غانم',
    major: 'المالية والاقتصاد',
    youtubeId: 'JteBHJQKxts',
  },
  {
    id: 'Ghada-Al-Hakim-mpc',
    student: 'د. غاده الحكيم',
    major: 'عمل اجتماعي',
    youtubeId: 'Hc_btXqwu2Y',
  },
  {
    id: 'Reebal-Bourjes-mpc',
    student: 'ريال بورجاس',
    major: 'هندسة الميكانيك',
    youtubeId: 'oL2AztOfbhE',
  },
  {
    id: 'Rana-Haydar-mpc',
    student: 'رنا حيدر',
    major: 'قابلة قانونية',
    youtubeId: 'b0pa96rcjk8',
  },
  {
    id: 'Katia-Bouadi-mpc',
    student: 'كاتيا بوادي',
    major: 'علاج النطق',
    youtubeId: 'yL-_AwtAnVA',
  },
  {
    id: 'carole-abou-chacra-legal',
    student: 'كارول أبو شقرا',
    major: 'محامي قانوني',
    youtubeId: 'JL2IawYYx50',
  },
  {
    id: 'celine-melhem-ot',
    student: 'سيلين ملحم',
    major: 'أخصائي العلاج الوظيفي',
    youtubeId: 'MNewCyqIFPk',
  },
  {
    id: 'dr-rodaina-kordab-pediatrician',
    student: 'د. رودينا قرطب',
    major: 'طبيبة أطفال',
    youtubeId: 'Conar80T6KU',
  },
  {
    id: 'dr-rola-salah-hassan-dentist',
    student: 'د. رلى صلاح حسن',
    major: 'حكيمة أسنان',
    youtubeId: 'e3wMoT5_MUs',
  },
  {
    id: 'sahar-al-chami-nursing',
    student: 'سحر الشامي',
    major: 'مدرّبة سريرية في التمريض',
    youtubeId: 'iSywUShHpok',
  },
  {
    id: 'dr-joelle-khoury-sawma-psychology',
    student: 'د. جويل خوري صوما',
    major: 'علم النفس السريري والعلاج النفسي',
    youtubeId: 'g8S2tD4BcEY',
  },
  {
    id: 'tamara-hatoum-ai-robotics',
    student: 'تمارا حاطوم',
    major: 'مدرّبة في مجال الروبوتيات والذكاء الاصطناعي',
    youtubeId: 'F5Z_k1aIHG4',
  },
];

export default videosAr;
